import { useState } from 'react';
import { Button } from 'ui';

import { useTranslation } from '@/i18n/client';
import { forgotPassword } from '@/modules/account/api';

import { SuccessScreen } from '../SuccessScreen';

import styles from './ChangePassword.module.scss';
import { ChangePasswordProps } from './types';

export function ChangePassword({
	changePasswordActive,
	setChangePasswordActive,
}: ChangePasswordProps) {
	const { t } = useTranslation(['header', 'common']);

	const [formSent, setFormSent] = useState<string | null>(null);
	const [isLoading, setIsLoading] = useState(false);

	const onSubmit = async () => {
		if (!changePasswordActive) {
			return;
		}

		setIsLoading(true);
		await forgotPassword(changePasswordActive);

		setFormSent(changePasswordActive);
	};

	return formSent ? (
		<SuccessScreen
			email={formSent}
			type="remindPassword"
			backToLoginPress={() => setChangePasswordActive(null)}
		/>
	) : (
		<div className={styles.changePassword__formWrapper}>
			<h2 className={styles.changePassword__title}>{t('authModal.passwordChange')}</h2>
			<p className={styles.changePassword__caption}>{t('authModal.passwordChangeDescription')}</p>
			<p className={styles.changePassword__caption}>
				{t('authModal.passwordChangeSecondDescription')}
			</p>

			<Button
				buttonName="sendButton"
				fullWidth
				variant="blue"
				type="button"
				isLoading={isLoading}
				isDisabled={isLoading}
				onPress={onSubmit}
			>
				{t('common:common.send')}
			</Button>

			<Button
				variant="iconButton"
				buttonName="backToLogin"
				onPress={() => setChangePasswordActive(null)}
			>
				{t('authModal.backToLogin')}
			</Button>
		</div>
	);
}
